import styled from "styled-components"
import { TextBaseProps } from "./types"

const Body = styled.div<TextBaseProps>`
  color: ${(props) => props.color ?? props.theme.colors.greyDark};
  text-align: ${(props) => props.textAlign ?? "left"};
  opacity: ${(props) => props.opacity ?? "1"};

  font-family: "Karla", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: ${(props) => props.weight ?? "500"};
  line-height: 23px;
`

export default Body
